import React from 'react';
import cn from 'classnames';

import {ITariff} from 'entities/tariff';

import {TARIFF_BADGES, TariffBadgeVariant} from './badges';

import styles from './TariffBadges.module.scss';

const VARIANT_CLASSES: Record<TariffBadgeVariant, string> = {
    default: styles.badgeDefault,
    recommended: styles.badgeRecommended,
    archive: styles.badgeArchive,
};

interface ITariffBadgesProps {
    item: ITariff,
}

const TariffBadges: React.FC<ITariffBadgesProps> = ({item}) => {
    const badges = TARIFF_BADGES.filter(({key}) => item[key]);

    if (badges.length === 0) {
        return null;
    }

    return (
        <div className={styles.badges}>
            {
                badges.map(({key, label, variant}) =>
                    <span key={key} className={cn(styles.badge, VARIANT_CLASSES[variant])}>{label}</span>,
                )
            }
        </div>
    );
};

export default React.memo(TariffBadges);
